import { HEADER_TRANSLATION_KEY } from '../constants';

export default {
  pt: {
    [HEADER_TRANSLATION_KEY]: {
      HEADER_ID_0_NAME: 'Partners',
      HEADER_ID_0_ITEM_1_NAME: 'Revendedores',
      HEADER_ID_0_ITEM_1_DESCRIPTION:
        'Promove o desenvolvimento profissional das pessoas.',
      HEADER_ID_0_ITEM_2_NAME: 'Referências',
      HEADER_ID_0_ITEM_2_DESCRIPTION: 'Indique a Crehana para sua empresa.',

      HEADER_ID_1_NAME: 'Produto',
      HEADER_ID_1_ITEM_1_NAME: 'Teste de XP de Habilidade',
      HEADER_ID_1_ITEM_1_DESCRIPTION:
        'Conheça as necessidades de estudo de seus funcionários.',
      HEADER_ID_1_ITEM_2_NAME: 'Mentoria',
      HEADER_ID_1_ITEM_2_DESCRIPTION:
        'Você sempre aprenderá na companhia de especialistas.',
      HEADER_ID_1_ITEM_3_NAME: 'Salas de aula',
      HEADER_ID_1_ITEM_3_DESCRIPTION:
        'Compartilhe material exclusivo de sua empresa.',
      HEADER_ID_1_ITEM_4_NAME: 'Análise de Dados',
      HEADER_ID_1_ITEM_4_DESCRIPTION: 'Acessar estatísticas em tempo real.',

      HEADER_ID_2_NAME: 'Academias',
      HEADER_ID_2_GROUP_1_TITLE: 'NOSSAS ACADEMIAS',
      HEADER_ID_2_GROUP_1_SUBITEM_1_NAME: 'Liderança',
      HEADER_ID_2_GROUP_1_SUBITEM_1_DESCRIPTION: 'Descubra o seu potencial.',
      HEADER_ID_2_GROUP_1_SUBITEM_2_NAME: 'Inovação',
      HEADER_ID_2_GROUP_1_SUBITEM_2_DESCRIPTION: 'Aumente a sua criatividade.',
      HEADER_ID_2_GROUP_1_SUBITEM_3_NAME: 'Marketing Digital',
      HEADER_ID_2_GROUP_1_SUBITEM_3_DESCRIPTION: 'Conheça o mundo digital.',
      HEADER_ID_2_GROUP_1_SUBITEM_4_NAME: 'Vendas',
      HEADER_ID_2_GROUP_1_SUBITEM_4_DESCRIPTION: 'Torne seus clientes leais.',
      HEADER_ID_2_GROUP_2_TITLE: 'NOSSAS ROTAS DE APRENDIZAGEM',
      HEADER_ID_2_GROUP_2_SUBITEM_1_NAME: 'Digital Mindset',
      HEADER_ID_2_GROUP_2_SUBITEM_1_DESCRIPTION: 'Lidere a transformação.',
      HEADER_ID_2_GROUP_2_SUBITEM_2_NAME: 'Análise de Dados',
      HEADER_ID_2_GROUP_2_SUBITEM_2_DESCRIPTION: 'Gerenciar estatísticas.',
      HEADER_ID_2_GROUP_2_SUBITEM_3_NAME: 'Comércio eletrônico',
      HEADER_ID_2_GROUP_2_SUBITEM_3_DESCRIPTION: 'Criar estratégias online.',
      HEADER_ID_2_GROUP_2_SUBITEM_4_NAME: 'UI & UX',
      HEADER_ID_2_GROUP_2_SUBITEM_4_DESCRIPTION: 'Otimize seu web design.',

      HEADER_ID_3_NAME: 'Recursos',
      HEADER_ID_3_ITEM_1_NAME: 'Blog',
      HEADER_ID_3_ITEM_1_DESCRIPTION:
        'Conteúdo relevante para a sua aprendizagem.',
      HEADER_ID_3_ITEM_2_NAME: 'Downloadable',
      HEADER_ID_3_ITEM_2_DESCRIPTION:
        'Ebooks, ferramentas, casos principais e mais.',

      HEADER_ID_4_NAME: 'Planos',

      HEADER_CALL_BUTTON: 'Ligue para nós',
      HEADER_FREE_TRIAL_BUTTON: 'Experimente gratuitamente',
      HEADER_FORM_PHONE_LABEL: 'Número de telefone',
      HEADER_FORM_PHONE_ERROR: 'Digite um número válido',
      HEADER_FORM_PHONE_BUTTON: 'Contato',

      HEADER_CONTACT_DIALOG_TITLE:
        'Entre em contato com nossa equipe \n de especialistas',
      HEADER_CONTACT_DIALOG_DESCRIPTION:
        'Estamos disponíveis de segunda a sexta, das 9h às 18h (PET)',

      HEADER_CONFIRMATION_DIALOG_TITLE:
        'Muito obrigado por \n registrar seus dados',
      HEADER_CONFIRMATION_DIALOG_DESCRIPTION:
        'Entraremos em contato em breve \n para que você possa viver esta experiência.',
      HEADER_CONFIRMATION_DIALOG_BUTTON: 'Concluir',

      CLE_CTA: 'Conoce más',
      CLE_TITLE: 'Ecosistema de Desarrollo de Personas',
      CLE_DESCRIPTION:
        'Antes de elegir un programa de training para tu equipo, asegúrate de que podrás contar con las estadísticas necesarias para saber el impacto que generará.',
    },
  },
};
